import React from 'react';
import { WindowLocation } from '@reach/router';
import { PublicSetWithEWebinarFragment } from '$/GraphQL/schema/schema';

export interface StaticSetState {
  staticset?: PublicSetWithEWebinarFragment;
  location?: WindowLocation;
}

export const StaticSetContext = React.createContext({} as StaticSetState);

export const useStaticSetContext = (): StaticSetState => {
  return React.useContext(StaticSetContext);
};
